import { useMediaQuery } from 'react-responsive';

export function useIsDesktop(minwidth = '980px') {
  const isDesktop = useMediaQuery({ query: `(max-width: ${minwidth})` });

  return !isDesktop;
}
